import axiosInstance from "../server/axios";

export const fetchUsers = (search, limit, page) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.get(`/utilisateurs`, {
        params: { search, limit, page },
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

export const addUser = (data) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.post(`/utilisateurs`, data, {
        headers: {
            'Content-Type': 'multipart/form-data', // For file uploads
            'Authorization': `Bearer ${token}`,
        },
    });
};

export const editUser = (userId, data) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.put(`/utilisateurs/${userId}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data', // For file uploads
            'Authorization': `Bearer ${token}`,
        },
    });
};

export const fetchClients = (search, limit, page) => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.get(`/utilisateursClient`, {
        params: { search, limit, page },
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
};
export const getAllClientEmail = () => {
    const token = localStorage.getItem('authToken');
    return axiosInstance.get(`/getAllClientEmail`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
};

// export const getAllRoles = () => {
//     const token = localStorage.getItem('authToken');
//     return axiosInstance.get(`/roles`, {
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': `Bearer ${token}`,
//         },
//     });
// }; 